var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider-with-text"},[_c('div',{staticClass:"divider-line"}),_vm._v(" "),_c('div',{staticClass:"divider-text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"divider-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }